import type { CSSProperties } from 'react';
import FieldMappingIconSvg from '../../assets/icons/field_mapping.svg?react';

export interface IconProps {
    size?: number | string;
    className?: string;
    style?: CSSProperties;
    onClick?: () => void;
}

const FieldMappingIcon: React.FC<IconProps> = ({
    size = 16,
    className = '',
    style = {},
    onClick,
}) => {
    const iconStyle: CSSProperties = {
        width: typeof size === 'number' ? `${size}px` : size,
        height: typeof size === 'number' ? `${size}px` : size,
        display: 'inline-block',
        fill: 'currentColor',
        ...style,
    };

    return <FieldMappingIconSvg className={className} style={iconStyle} onClick={onClick} />;
};

export default FieldMappingIcon;
